export function filterPois(pois) {
	return pois.filter(
		(p) =>
			Object.keys(p.tags).length !== 0 &&
			(p.tags.amenity || p.tags.shop || p.tags.tourism || p.tags.leisure || p.tags.historic || p.tags.office) &&
			p.tags.tourism !== 'artwork' &&
			p.tags.name &&
			p.tags.access !== 'private' &&
			p.tags.amenity !== 'bench' &&
			p.tags.amenity !== 'waste_basket' &&
			p.tags.amenity !== 'fountain' &&
			p.tags.amenity !== 'parking' &&
			p.tags.amenity !== 'bicycle_parking' &&
			p.tags.amenity !== 'recycling' &&
			p.tags.leisure !== 'park' &&
			p.tags.leisure !== 'pitch' &&
			p.tags.historic !== 'memorial'
	);
}
